module.exports = __webpack_public_path__ + "img/guides-bg.02d72e86.jpg";